import type { BdrLead, BdrStats } from '@/types'
import { DEFAULT_BDR_ID } from '@/utils/bdrDefaultSelection'

export const OPERATIONAL_BDR_ID = DEFAULT_BDR_ID
export const OPERATIONAL_BDR_NAME = 'Sophia Brígido'
export const MIN_DORES_LENGTH = 10

export function getHorarioSugestao(cad: { fase?: number; tentativa?: number } | null) {
  if (!cad) return { label: 'Agendado', color: 'text-amber-500' }
  if ((cad.fase ?? 0) >= 3 || (cad.tentativa ?? 0) >= 5) {
    return { label: 'Tarde', color: 'text-orange-500' }
  }
  return { label: 'Manhã', color: 'text-blue-500' }
}

export function getLeadMeetingDate(lead: BdrLead) {
  const firstDeal = lead.deals?.[0] as { reunioes?: { data?: string }[]; Reuniao?: { data?: string }[] }
  const meeting = firstDeal?.reunioes?.[0] || firstDeal?.Reuniao?.[0]
  return meeting?.data || ''
}

export function emptyStats(): BdrStats {
  return {
    total: 0,
    hoje: { ligacoes: 0, whatsapp: 0, contatos: 0, reunioes: 0 },
    mes: { reunioesAgendadas: 0, reunioesRealizadas: 0 },
    conversionRate: 0,
    conversionVelocity: 0,
    noShowRate: 0,
    sqlGeneratedWeek: 0,
    planejamentoAmanha: 0,
    nurturing: 0,
  }
}

export function emptyNewLead() {
  return {
    empresa: '',
    contato: '',
    cargo: '',
    telefone: '',
    email: '',
    site: '',
    segmento: '',
    plataforma: '',
    modelo: '',
    faturamento: '',
    origem: '',
    problema: '',
    observacoes: '',
    servicos: [] as string[],
    trafego: '',
    cnpj: '',
    parceiroId: '',
    empresaId: '',
  }
}

export function emptyRegTentativa() {
  return {
    canal: '',
    resultado: '',
    obs: '',
    email: '',
    dores: '',
    closerId: '',
    dataReuniao: '',
    horaReuniao: '',
  }
}
